import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const AGREEMENT_OR_SETTLEMENT = {
  YES: 'yes',
  NO: 'no',
} as const;

export const AGREEMENT_OR_SETTLEMENT_NAME = 'agreement_or_settlement';
export const AGREEMENT_OR_SETTLEMENT_NAME_COMPLEMENTARY =
  'agreement_or_settlement_complementary';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const RadioGroupAgreementOrSettlement: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  const fieldName =
    name ??
    (isComplementary
      ? AGREEMENT_OR_SETTLEMENT_NAME_COMPLEMENTARY
      : AGREEMENT_OR_SETTLEMENT_NAME);

  return (
    <FormField
      control={control}
      name={fieldName}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t(
              'Czy były zawierane mailowo lub telefonicznie jakiekolwiek ugody lub porozumienia dotyczące odszkodowania?'
            )}
          </FormLabel>
          <FormControl>
            <RadioGroup
              {...field}
              layout={'horizontal'}
              data-testid="radio-group-agreement-or-settlement"
            >
              <RadioItem
                value={AGREEMENT_OR_SETTLEMENT.YES}
                label={i18n.t('Tak')}
                data-testid="radio-item-agreement-or-settlement-yes"
              />
              <RadioItem
                value={AGREEMENT_OR_SETTLEMENT.NO}
                label={i18n.t('Nie')}
                data-testid="radio-item-agreement-or-settlement-no"
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
